
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'catalog-product-bundle-add-to-cart',
  components: {
    ...ServiceContainer().getComponents(),
    'catalog-product-add-to-cart-modal': () => import('./ProductAddToCartModal.vue'),
  },
})

export default class extends Vue {
  @Prop({required: true}) private bundleItems: Array<object>;
  @Prop({required: true}) private product: object;

  private isLoading: boolean = false;
  private addedToCart: boolean = false;
  private addToCartFailed: boolean = false;
  private showModal: boolean = false;

  private async addToQuoteAction(): Promise<void> {
    this.isLoading = true;

    try {
      for (let i = 0; i < this.bundleItems.length; i++) {
        await this.$store.dispatch('Quote/addQuoteItem', {
          sku: this.bundleItems[i]['sku'],
          qty: this.bundleItems[i]['qty']
        });
      }

      this.addedToCart = true;
      this.showModal = true;
    } catch ({response}) {
      console.error(response.data);
      this.addToCartFailed = true;
      return;
    }

    await this.$store.dispatch('Quote/fetchQuote');

    this.resetButtonState();
  }

  private resetButtonState(): void {
    this.isLoading = false;

    setTimeout(() => {
      this.addedToCart = false;
      this.addToCartFailed = false;
    }, 3000);
  }
}
